"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

var _tcombForm = require("tcomb-form");

var form = _interopRequireWildcard(_tcombForm);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _AppDataField = require("../AppDataField");

var _ReportDetailAddTypeUncontrolledModal = require("../../../containers/reportDetail/ReportDetailAddTypeUncontrolledModal");

var _ReportDetailAddTypeUncontrolledModal2 = _interopRequireDefault(_ReportDetailAddTypeUncontrolledModal);

var _actions = require("../actions");

var reportDetailActions = _interopRequireWildcard(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectTypeAppDataField = function SelectTypeAppDataField(dataField, contentDataField, reportData) {
    var _this = this;

    var isWithinTable = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

    _classCallCheck(this, SelectTypeAppDataField);

    this.nameSingular = null;
    this.disabled = false;
    this.key = function () {
        return _this.dataField.uid;
    };
    this.appSchemaObject = function () {
        var schema = {};
        _.set(schema, _this.key(), _this.dataField.isMandatory ? t.String : t.maybe(t.String));
        return schema;
    };
    this.appSchemaStruct = function () {
        return t.struct(_this.appSchemaObject(), _this.dataField.uid);
    };
    this.template = function (locals) {
        // console.log(this);
        return React.createElement("div", { style: { width: _AppDataField.containerWidth } }, form.form.Form.templates.select.clone()(locals), function () {
            return React.createElement(_ReportDetailAddTypeUncontrolledModal2.default, { reportDataDefinitionUid: _this.dataField.refUid, nameSingular: _this.nameSingular, onSuccess: _this.addValue, disabled: _this.disabled });
        }());
    };
    this.addValue = function (dispatch, value) {
        _this.setValue(value);
        if (value) {
            dispatch(reportDetailActions.updateReportWithAppDataField(_this));
        }
    };
    this.setValue = function (value) {
        value = value || null;
        _.set(_this, "contentDataField.data.uid", value);
    };
    this.appSchemaFieldOptions = function (formattedMessage) {
        var disabled = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

        _this.disabled = disabled;
        var field = {};
        _.set(field, _this.key(), {
            label: (0, _AppDataField.labelHelper)(_this.dataField.title, _this.dataField.isMandatory, _this.isWithinTable, formattedMessage),
            help: (0, _AppDataField.helpContainer)(true, _this.dataField.description),
            options: _this.options,
            factory: form.form.Select,
            template: _this.template,
            disabled: disabled
        });
        return field;
    };
    this.currentFormValue = function () {
        return (0, _selectn2.default)("data.uid", _this.contentDataField);
    };
    this.copy = function () {
        return new SelectTypeAppDataField(_this.dataField, _this.contentDataField, _this.reportData);
    };
    this.contentDataField = contentDataField;
    this.dataField = dataField;
    this.reportData = reportData;
    this.isWithinTable = isWithinTable;
    this.contentDataField = Object.assign({}, contentDataField, {
        type: "reference",
        uid: dataField.uid
    });
    var relevantReportDataDef = null;
    var additionalInfo = "";
    this.options = _.chain(reportData).filter(function (reportData) {
        return reportData.dataDefinition.uid === dataField.refUid;
    }).map(function (reportData) {
        relevantReportDataDef = reportData.dataDefinition;
        // set singular name of referenced instance schema...
        _this.nameSingular = relevantReportDataDef.nameSingular;
        return reportData.dataEntries;
    }).flatten().map(function (reportContentGeneric) {
        var infoTitle = relevantReportDataDef.additionalInfoTitle;
        var info = reportContentGeneric.additionalInfo;
        // add additionalInfo to text...
        if (infoTitle && info) {
            additionalInfo = " (" + infoTitle + ": " + info + ")";
        } else if (info) {
            additionalInfo = " (" + info + ")";
        }
        return {
            value: reportContentGeneric.uid,
            text: reportContentGeneric.title + additionalInfo
        };
    }).value();
    if (!this.nameSingular) {
        console.error("failed to look up for relevant def, add button type will be disabled", dataField.refUid, reportData, this.dataField, this.isWithinTable, this.contentDataField);
    }
    this.setValue(this.currentFormValue());
};

exports.default = SelectTypeAppDataField;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/fields/SelectTypeAppDataField.tsx
 ** module id = 1295
 ** module chunks = 0
 **/